import { useEffect, useState } from 'react';
import { ItfSceneProductCard, ItfSceneProductCardInput } from './type';
import { getSolarRecommand2 } from '@/service/solar-calculator';

type RequestStatus = 'idle' | 'loading' | 'success' | 'error';
type ProductListResponse = {
    code?: string;
    message?: string;
    data?: ItfSceneProductCard[];
};

export function useSceneProducts(cards: ItfSceneProductCardInput[], locale: string) {
    const [productInfoMap, setProductInfoMap] = useState<Record<string, ItfSceneProductCard>>({});
    const [requestStatus, setRequestStatus] = useState<RequestStatus>('idle');
    const [resolvedKey, setResolvedKey] = useState('');
    const variantIdsKey = cards
        .map((card) => card.variantId)
        .filter(Boolean)
        .join(',');

    useEffect(() => {
        setProductInfoMap({});
        setResolvedKey('');
        if (!variantIdsKey || !locale) {
            setRequestStatus('idle');
            return;
        }
        let cancelled = false;
        setRequestStatus('loading');
        getSolarRecommand2({ variantIds: variantIdsKey.split(',') }, locale)
            .then((res: ProductListResponse) => {
                if (cancelled) return;
                if (res?.code && res.code !== '0') {
                    console.error(res.message);
                    setRequestStatus('error');
                    return;
                }
                const list = Array.isArray(res?.data) ? res.data : [];
                const map: Record<string, ItfSceneProductCard> = {};
                list.forEach((item: ItfSceneProductCard) => {
                    if (item?.variantId) map[String(item.variantId)] = item;
                });
                setProductInfoMap(map);
                setResolvedKey(variantIdsKey);
                setRequestStatus('success');
            })
            .catch((error) => {
                if (cancelled) return;
                console.error(error);
                setRequestStatus('error');
            });

        return () => {
            cancelled = true;
        };
    }, [variantIdsKey, locale]);

    return cards
        .map((config) => {
            if (!config.variantId) return config;
            const info = productInfoMap[String(config.variantId)];
            // 请求成功但接口未返回该 variant，表示商品已下架，整卡不展示。
            if (requestStatus === 'success' && resolvedKey === variantIdsKey && !info) return null;
            return {
                ...info,
                ...config,
                handle: info?.handle || config.handle,
                variantImg: info?.variantImg || config.img,
                skuTitle: config.skuTitle || config.title || info?.skuTitle,
                productTitle: config.title || info?.productTitle,
                inventoryQuantity: info?.inventoryQuantity,
                inventoryPolicy: info?.inventoryPolicy,
                price: info?.price,
                compareAtPrice: info?.compareAtPrice,
            };
        })
        .filter(Boolean) as ItfSceneProductCard[];
}
